module.exports = __webpack_public_path__ + "img/logo_chomtana_erp.fd283dbe.png";